<div class="wk8-book-contents" style="display: grid; gap: 1em; font-size: calc(1vw + 1vh)">
  @for (sentence of sentences(); track sentence.uid) {
    @let _clickable = mode() === 'LEVEL_SELECT' && !isSentenceComplete(sentence);
    @let _isHighlightedSentence = highlightedSentence() ? highlightedSentence()?.uid === sentence.uid : true;
    <wk8-book-sentence
      [sentence]="sentence"
      [enableLevelSelect]="_clickable"
      [target]="target()"
      [highlightedPart]="mode() === 'LEVEL_SELECT' ? highligtedPart() : undefined"
      [enableTarget]="_isHighlightedSentence"
      [enableWordFill]="mode() === 'WORD_FILL'"
      style="display: block"
      [style.opacity]="_isHighlightedSentence ? 1 : 0.5"
      (hovered)="highligtedPart.set($event)"
      (wordFilled)="wordFilled.emit($event)"
      (levelSelected)="startLevel(sentence, $event)"
    />
  }
</div>
